import api from "../api/axios";

export const USER_ROLE_QUERY_KEY = ["user-role"];

export const userRoleService = {
  getAllUserRole: async (emp_no: string) => {
    const response = await api.get(`api/users/${emp_no}/roles`);
    return response.data;
  },
  assignRoles: async (emp_no: string, roleIds: number[]) => {
    const payload = {
      role_ids: roleIds,
    };
    const response = await api.post(`api/users/${emp_no}/roles`, payload);
    return response.data;
  },
  removeRole: async (emp_no: string, roleId: number) => {
    const response = await api.delete(`api/users/${emp_no}/roles/${roleId}`);
    return response.data;
  },
};
